import { useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";

export function NewsletterBlock({ compact }) {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setLoading(true);
    try {
      const { data } = await api.post("/newsletter/subscribe", { email });
      toast.success(data.message || "Subscribed.");
      setEmail("");
    } catch (err) {
      toast.error("Could not subscribe. Please try again.");
    } finally { setLoading(false); }
  };
  return (
    <div className={compact ? "" : "bg-ink text-paper p-8 sm:p-12"} data-testid="newsletter-block">
      <div className="text-xs font-bold uppercase tracking-[0.2em] text-crimson">The Fin Desk Daily</div>
      <h3 className={`font-serif ${compact ? "text-2xl" : "text-3xl sm:text-4xl"} font-semibold mt-2 leading-tight ${compact ? "text-ink" : "text-paper"}`}>
        The essential developments in modern finance
      </h3>
      <p className={`mt-3 text-sm leading-relaxed max-w-lg ${compact ? "text-ink2" : "text-paper/70"}`}>
        The essential developments across fintech, payments and modern finance — delivered to your inbox.
      </p>
      <form onSubmit={submit} className="mt-5 flex flex-col sm:flex-row gap-2 max-w-md">
        <input data-testid="newsletter-email-input" type="email" required value={email}
          onChange={(e) => setEmail(e.target.value)} placeholder="you@company.com"
          className={`flex-1 px-4 py-3 text-sm outline-none border ${compact ? "border-hair bg-white text-ink" : "border-paper/30 bg-transparent text-paper placeholder:text-paper/40"} focus:border-crimson`} />
        <button data-testid="newsletter-submit-button" disabled={loading}
          className="px-6 py-3 bg-crimson hover:bg-crimsonhover text-white text-sm font-semibold uppercase tracking-wider transition-colors disabled:opacity-60">
          {loading ? "…" : "Subscribe"}
        </button>
      </form>
      <p className={`mt-3 text-xs ${compact ? "text-mutedink" : "text-paper/50"}`}>
        Free. No spam. Unsubscribe anytime.
      </p>
    </div>
  );
}
